import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown, Form, FormControl, Button, Container, Row, Col, Accordion } from 'react-bootstrap'; // Type defintitions

import * as TYPES from '../../types';
import Heading from '../../components/heading/Heading';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import Modal from '../modal/Modal';
import Newsletter from '../forms/Newsletter';
import { replaceJSSString, hideFooterHeader } from "../../util";
import { SitecoreLink } from '../link/Link'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);

  var _super = _createSuper(Footer);

  _createClass(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupToggleOneTrust();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeToggleOneTrust();
    }
  }]);

  function Footer() {
    var _this;

    _classCallCheck(this, Footer);

    _this = _super.call(this);
    _this.state = {
      showMenu: false
    };

    _this.toggleModal = function () {
      _this.setState({
        show: !_this.state.show
      });
    };

    _this.pushGaFooter = function (id, title, htmlId) {
      var data = {
        gtm: {
          uniqueEventId: id,
          // '22'
          elementTarget: title,
          elementId: htmlId
        },
        event: 'gtm.click'
      };
      gaTracker(data);
    };

    _this.footerMenuClick = function (title, htmlId) {
      _this.pushGaFooter(56, title, htmlId);
    };

    _this.footerSocialClick = function (title, htmlId) {
      _this.pushGaFooter(57, title, htmlId);
    };

    _this.footerLegalClick = function (title, htmlId) {
      _this.pushGaFooter(59, title, htmlId);
    };

    _this.ctaClick = function (title, htmlId) {
      _this.pushGaFooter(60, title, htmlId);
    };

    _this.toggleMenu = _this.toggleMenu.bind(_assertThisInitialized(_this));
    _this.optOutClickHandler = _this.optOutClickHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Footer, [{
    key: "toggleMenu",
    value: function toggleMenu() {
      var count = this.state.count;
      this.setState({
        count: count + 1
      });
    }
  }, {
    key: "optOutClickHandler",
    //functions for calling OneTrust toggle display in smalllinks with class otOptOut
    value: function optOutClickHandler(e) {
      var clickedElement = e.target;

      if (clickedElement.classList.contains('otOptOut')) {
        OneTrust.ToggleInfoDisplay();
      }
    }
  }, {
    key: "setupToggleOneTrust",
    value: function setupToggleOneTrust() {
      document.addEventListener('click', this.optOutClickHandler);
    }
  }, {
    key: "removeToggleOneTrust",
    value: function removeToggleOneTrust() {
      document.removeEventListener('click', this.optOutClickHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _model$downloadAppUrl5,
          _model$downloadAppUrl6,
          _model$downloadAppUrl8,
          _model$subscribeCta4,
          _model$subscribeCta6,
          _model$joinTeamCta4,
          _model$joinTeamCta4$v,
          _model$joinTeamCta6,
          _model$copyrightText2;

      var _this$props = this.props,
          _this$props$navigatio = _this$props.navigation,
          navigation = _this$props$navigatio === void 0 ? {} : _this$props$navigatio,
          _this$props$model = _this$props.model,
          model = _this$props$model === void 0 ? {} : _this$props$model,
          isCnbSite = _this$props.isCnbSite;
      var show = this.state.show; //If site context is cnb then show cnb footer

      if (isCnbSite) {
        var _model$downloadAppUrl, _model$downloadAppUrl2, _model$downloadAppUrl4, _model$subscribeCta, _model$subscribeCta3, _model$joinTeamCta, _model$joinTeamCta$va, _model$joinTeamCta3, _model$copyrightText;

        return !hideFooterHeader() && /*#__PURE__*/React.createElement("div", {
          id: "cb-footer",
          className: "cb-footer"
        }, /*#__PURE__*/React.createElement(Container, {
          className: "cb-footer__container"
        }, /*#__PURE__*/React.createElement(Row, {
          className: ""
        }, /*#__PURE__*/React.createElement(Col, {
          lg: "12"
        }, /*#__PURE__*/React.createElement(Row, {
          className: "cb-footer__nav-container"
        }, navigation.footerLinks && navigation.footerLinks.map(function (item, index) {
          var _model$item$value;

          var model = {
            item: item.link.jss,
            children: item.children
          };
          return /*#__PURE__*/React.createElement(React.Fragment, {
            key: index
          }, /*#__PURE__*/React.createElement(Col, {
            className: "d-none d-md-block"
          }, /*#__PURE__*/React.createElement("ul", {
            className: "cb-footer__nav cb-footer__content"
          }, /*#__PURE__*/React.createElement("li", {
            class: "text-center"
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            field: model.item,
            className: "cb-footer__nav-parent"
          }), model.children.length ? /*#__PURE__*/React.createElement("ul", {
            className: "cb-footer__sub-nav"
          }, model.children.map(function (item, index) {
            return /*#__PURE__*/React.createElement("li", {
              key: "footer-sub-".concat(index)
            }, /*#__PURE__*/React.createElement(SitecoreLink, {
              className: "nav-link",
              id: "footer-sub-".concat(index),
              onClick: function onClick() {
                return _this2.footerMenuClick(item.link.jss.value.text, "footer-sub-".concat(index));
              },
              field: item.link.jss
            }));
          })) : ''))), /*#__PURE__*/React.createElement(Col, {
            className: "d-xs-block d-md-none",
            lg: "3"
          }, /*#__PURE__*/React.createElement("ul", {
            className: "cb-footer__nav cb-footer__content"
          }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Accordion.Toggle, {
            eventKey: "footerToggle-".concat(index),
            className: "cb-footer__".concat(model.children.length > 0 ? 'toggle' : 'no-toggle', " text-center"),
            as: Nav,
            variant: "link"
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            field: model.item
          }, (_model$item$value = model.item.value) === null || _model$item$value === void 0 ? void 0 : _model$item$value.text)), model.children.length ? /*#__PURE__*/React.createElement(Accordion.Collapse, {
            eventKey: "footerToggle-".concat(index)
          }, /*#__PURE__*/React.createElement("ul", {
            className: "cb-footer__sub-nav d-block"
          }, model.children.map(function (item, index) {
            return /*#__PURE__*/React.createElement("li", {
              key: "footer-sub-".concat(index)
            }, /*#__PURE__*/React.createElement(SitecoreLink, {
              className: "nav-link",
              field: item.link.jss
            }));
          }))) : '')))));
        })))), navigation.socialLinks.length > 0 && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          lg: "12",
          className: "cb-l-margin-medium--bottom cb-footer__content-container"
        }, /*#__PURE__*/React.createElement(Heading, {
          level: "4",
          className: "cb-type-subheading-2",
          field: model.socialTitle
        }), /*#__PURE__*/React.createElement("ul", {
          className: "cb-footer__content cb-list--inline"
        }, Array.isArray(navigation.socialLinks) && navigation.socialLinks.map(function (item, index) {
          var _item$link, _item$socialIcon;

          var model = {
            item: (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.jss,
            icon: (_item$socialIcon = item.socialIcon) === null || _item$socialIcon === void 0 ? void 0 : _item$socialIcon.jss
          };
          return /*#__PURE__*/React.createElement("li", {
            key: index
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            field: model.item,
            className: "cb-footer__social-link",
            id: "footer-social-".concat(index),
            target: "_blank",
            onClick: function onClick() {
              return _this2.footerSocialClick(item.link.jss.value, "footer-social-".concat(index));
            }
          }, /*#__PURE__*/React.createElement(Image, {
            className: "cb-footer__icon",
            field: model.icon
          })));
        })), ((_model$downloadAppUrl = model.downloadAppUrl) === null || _model$downloadAppUrl === void 0 ? void 0 : (_model$downloadAppUrl2 = _model$downloadAppUrl.value) === null || _model$downloadAppUrl2 === void 0 ? void 0 : _model$downloadAppUrl2.text) && /*#__PURE__*/React.createElement("div", {
          className: "cb-footer__content"
        }, /*#__PURE__*/React.createElement(SitecoreLink, {
          field: model.downloadAppUrl,
          id: "footer-downloadApp",
          onClick: function onClick() {
            var _model$downloadAppUrl3;

            return _this2.ctaClick((_model$downloadAppUrl3 = model.downloadAppUrl) === null || _model$downloadAppUrl3 === void 0 ? void 0 : _model$downloadAppUrl3.value.text, "footer-downloadApp");
          }
        }, /*#__PURE__*/React.createElement(Heading, {
          level: "4",
          className: "cb-type-subheading-2",
          field: {
            value: (_model$downloadAppUrl4 = model.downloadAppUrl) === null || _model$downloadAppUrl4 === void 0 ? void 0 : _model$downloadAppUrl4.value.text
          }
        }))), ((_model$subscribeCta = model.subscribeCta) === null || _model$subscribeCta === void 0 ? void 0 : _model$subscribeCta.value) && /*#__PURE__*/React.createElement("div", {
          className: "cb-footer__content"
        }, /*#__PURE__*/React.createElement("a", {
          id: "footer-subscribe",
          onClick: function onClick(event) {
            var _model$subscribeCta2;

            _this2.ctaClick((_model$subscribeCta2 = model.subscribeCta) === null || _model$subscribeCta2 === void 0 ? void 0 : _model$subscribeCta2.value, "footer-subscribe");

            _this2.toggleModal();
          }
        }, /*#__PURE__*/React.createElement(Heading, {
          level: "4",
          className: "cb-type-subheading-2",
          field: model.subscribeCta
        })), /*#__PURE__*/React.createElement(Modal, {
          show: show,
          hide: this.toggleModal,
          title: (_model$subscribeCta3 = model.subscribeCta) === null || _model$subscribeCta3 === void 0 ? void 0 : _model$subscribeCta3.value
        }, /*#__PURE__*/React.createElement(Newsletter, {
          closeModal: this.toggleModal
        }))), ((_model$joinTeamCta = model.joinTeamCta) === null || _model$joinTeamCta === void 0 ? void 0 : (_model$joinTeamCta$va = _model$joinTeamCta.value) === null || _model$joinTeamCta$va === void 0 ? void 0 : _model$joinTeamCta$va.text) && /*#__PURE__*/React.createElement("div", {
          className: "cb-footer__content"
        }, /*#__PURE__*/React.createElement(SitecoreLink, {
          field: model.joinTeamCta,
          id: "footer-joinTeam",
          onClick: function onClick() {
            var _model$joinTeamCta2;

            return _this2.ctaClick((_model$joinTeamCta2 = model.joinTeamCta) === null || _model$joinTeamCta2 === void 0 ? void 0 : _model$joinTeamCta2.value.text, "footer-joinTeam");
          }
        }, /*#__PURE__*/React.createElement(Heading, {
          level: "4",
          className: "cb-type-subheading-2",
          field: {
            value: (_model$joinTeamCta3 = model.joinTeamCta) === null || _model$joinTeamCta3 === void 0 ? void 0 : _model$joinTeamCta3.value.text
          }
        }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          className: "cb-footer__legal-nav"
        }, /*#__PURE__*/React.createElement("ul", null, navigation.smallFooterLinks && navigation.smallFooterLinks.map(function (item, index) {
          return /*#__PURE__*/React.createElement("li", {
            key: index
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            className: "".concat("nav-link ".concat(item.link.jss.value.class)),
            id: "legal-footer-".concat(index),
            onClick: function onClick() {
              return _this2.footerLegalClick(item.link.jss.value.text, "legal-footer-".concat(index));
            },
            field: item.link.jss
          }));
        })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
          tag: "p",
          field: replaceJSSString(model === null || model === void 0 ? void 0 : (_model$copyrightText = model.copyrightText) === null || _model$copyrightText === void 0 ? void 0 : _model$copyrightText.value),
          className: "cb-footer__legal-copy"
        })))));
      }

      return !hideFooterHeader() && /*#__PURE__*/React.createElement("div", {
        id: "cb-footer",
        className: "cb-footer"
      }, /*#__PURE__*/React.createElement(Container, {
        className: "cb-footer__container"
      }, /*#__PURE__*/React.createElement(Row, {
        className: ""
      }, /*#__PURE__*/React.createElement(Col, {
        lg: "12"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "cb-footer__nav-container"
      }, navigation.footerLinks && navigation.footerLinks.map(function (item, index) {
        var _model$item$value2;

        var model = {
          item: item.link.jss,
          children: item.children
        };
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement(Col, {
          className: "d-none d-md-block"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "cb-footer__nav cb-footer__content"
        }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SitecoreLink, {
          field: model.item,
          className: "cb-footer__nav-parent"
        }), model.children.length ? /*#__PURE__*/React.createElement("ul", {
          className: "cb-footer__sub-nav"
        }, model.children.map(function (item, index) {
          return /*#__PURE__*/React.createElement("li", {
            key: "footer-sub-".concat(index)
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            className: "nav-link",
            id: "footer-sub-".concat(index),
            onClick: function onClick() {
              return _this2.footerMenuClick(item.link.jss.value.text, "footer-sub-".concat(index));
            },
            field: item.link.jss
          }));
        })) : ''))), /*#__PURE__*/React.createElement(Col, {
          className: "d-xs-block d-md-none",
          lg: "3"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "cb-footer__nav cb-footer__content"
        }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Accordion.Toggle, {
          eventKey: "footerToggle-".concat(index),
          className: "cb-footer__toggle",
          as: Nav,
          variant: "link"
        }, /*#__PURE__*/React.createElement(SitecoreLink, {
          field: model.item
        }, (_model$item$value2 = model.item.value) === null || _model$item$value2 === void 0 ? void 0 : _model$item$value2.text)), model.children.length ? /*#__PURE__*/React.createElement(Accordion.Collapse, {
          eventKey: "footerToggle-".concat(index)
        }, /*#__PURE__*/React.createElement("ul", {
          className: "cb-footer__sub-nav d-block"
        }, model.children.map(function (item, index) {
          return /*#__PURE__*/React.createElement("li", {
            key: "footer-sub-".concat(index)
          }, /*#__PURE__*/React.createElement(SitecoreLink, {
            className: "nav-link",
            field: item.link.jss
          }));
        }))) : '')))));
      })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        lg: "12",
        className: "cb-l-margin-medium--bottom cb-footer__content-container"
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "4",
        className: "cb-type-subheading-2",
        field: model.socialTitle
      }), /*#__PURE__*/React.createElement("ul", {
        className: "cb-footer__content cb-list--inline"
      }, Array.isArray(navigation.socialLinks) && navigation.socialLinks.map(function (item, index) {
        var _item$link2, _item$socialIcon2;

        var model = {
          item: (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.jss,
          icon: (_item$socialIcon2 = item.socialIcon) === null || _item$socialIcon2 === void 0 ? void 0 : _item$socialIcon2.jss
        };
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(SitecoreLink, {
          field: model.item,
          className: "cb-footer__social-link",
          id: "footer-social-".concat(index),
          target: "_blank",
          onClick: function onClick() {
            return _this2.footerSocialClick(item.link.jss.value, "footer-social-".concat(index));
          }
        }, /*#__PURE__*/React.createElement(Image, {
          className: "cb-footer__icon",
          field: model.icon
        })));
      })), ((_model$downloadAppUrl5 = model.downloadAppUrl) === null || _model$downloadAppUrl5 === void 0 ? void 0 : (_model$downloadAppUrl6 = _model$downloadAppUrl5.value) === null || _model$downloadAppUrl6 === void 0 ? void 0 : _model$downloadAppUrl6.text) && /*#__PURE__*/React.createElement("div", {
        className: "cb-footer__content"
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        field: model.downloadAppUrl,
        id: "footer-downloadApp",
        onClick: function onClick() {
          var _model$downloadAppUrl7;

          return _this2.ctaClick((_model$downloadAppUrl7 = model.downloadAppUrl) === null || _model$downloadAppUrl7 === void 0 ? void 0 : _model$downloadAppUrl7.value.text, "footer-downloadApp");
        }
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "4",
        className: "cb-type-subheading-2",
        field: {
          value: (_model$downloadAppUrl8 = model.downloadAppUrl) === null || _model$downloadAppUrl8 === void 0 ? void 0 : _model$downloadAppUrl8.value.text
        }
      }))), ((_model$subscribeCta4 = model.subscribeCta) === null || _model$subscribeCta4 === void 0 ? void 0 : _model$subscribeCta4.value) && /*#__PURE__*/React.createElement("div", {
        className: "cb-footer__content"
      }, /*#__PURE__*/React.createElement("a", {
        id: "footer-subscribe",
        onClick: function onClick(event) {
          var _model$subscribeCta5;

          _this2.ctaClick((_model$subscribeCta5 = model.subscribeCta) === null || _model$subscribeCta5 === void 0 ? void 0 : _model$subscribeCta5.value, "footer-subscribe");

          _this2.toggleModal();
        }
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "4",
        className: "cb-type-subheading-2",
        field: model.subscribeCta
      })), /*#__PURE__*/React.createElement(Modal, {
        show: show,
        hide: this.toggleModal,
        title: (_model$subscribeCta6 = model.subscribeCta) === null || _model$subscribeCta6 === void 0 ? void 0 : _model$subscribeCta6.value
      }, /*#__PURE__*/React.createElement(Newsletter, {
        closeModal: this.toggleModal
      }))), ((_model$joinTeamCta4 = model.joinTeamCta) === null || _model$joinTeamCta4 === void 0 ? void 0 : (_model$joinTeamCta4$v = _model$joinTeamCta4.value) === null || _model$joinTeamCta4$v === void 0 ? void 0 : _model$joinTeamCta4$v.text) && /*#__PURE__*/React.createElement("div", {
        className: "cb-footer__content"
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        field: model.joinTeamCta,
        id: "footer-joinTeam",
        onClick: function onClick() {
          var _model$joinTeamCta5;

          return _this2.ctaClick((_model$joinTeamCta5 = model.joinTeamCta) === null || _model$joinTeamCta5 === void 0 ? void 0 : _model$joinTeamCta5.value.text, "footer-joinTeam");
        }
      }, /*#__PURE__*/React.createElement(Heading, {
        level: "4",
        className: "cb-type-subheading-2",
        field: {
          value: (_model$joinTeamCta6 = model.joinTeamCta) === null || _model$joinTeamCta6 === void 0 ? void 0 : _model$joinTeamCta6.value.text
        }
      }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        className: "cb-footer__legal-nav"
      }, /*#__PURE__*/React.createElement("ul", null, navigation.smallFooterLinks && navigation.smallFooterLinks.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(SitecoreLink, {
          className: "".concat("nav-link ".concat(item.link.jss.value.class)),
          id: "legal-footer-".concat(index),
          onClick: function onClick() {
            return _this2.footerLegalClick(item.link.jss.value.text, "legal-footer-".concat(index));
          },
          field: item.link.jss
        }));
      })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
        tag: "p",
        field: replaceJSSString(model === null || model === void 0 ? void 0 : (_model$copyrightText2 = model.copyrightText) === null || _model$copyrightText2 === void 0 ? void 0 : _model$copyrightText2.value),
        className: "cb-footer__legal-copy"
      })))));
    }
  }]);

  return Footer;
}(Component);

export default Footer;